import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  AllocationList,
  AllocationListPayload,
  IAllocationListResponse,
  IFailedPayload,
} from '../../types/Allocation.types';

export interface AllocationListState {
  data: AllocationList[] | [] | any[];
  page: number;
  pageSize: number;
  totalRecords: number;
  loading: boolean;
  error: IFailedPayload | null;
  allocationDeleteStatus: boolean;
  distinctValues: string[];
  distinctValuesLoading: boolean;
}

export const allocationInitState: AllocationListState = {
  data: [],
  page: 0,
  pageSize: 0,
  totalRecords: 0,
  loading: false,
  error: null,
  allocationDeleteStatus: false,
  distinctValues: [],
  distinctValuesLoading: false,
};

const allocationListSlice = createSlice({
  name: 'allocationListTable',
  initialState: allocationInitState,
  reducers: {
    fetchAllocationList(state, action: PayloadAction<AllocationListPayload>) {
      state.loading = true;
      state.error = null;
    },
    fetchAllocationListSuccess(
      state,
      action: PayloadAction<IAllocationListResponse>
    ) {
      state.data = action.payload.data.items;
      state.totalRecords = action.payload.data.pagination.total;
      state.pageSize = action.payload.data.pagination.pageSize;
      state.page = action.payload.data.pagination.page;
      state.loading = false;
      state.error = null;
    },
    setAllocationListPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setAllocationListPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
    },
    setAllocationListData(state, action: PayloadAction<AllocationList[]>) {
      state.data = action.payload;
    },
    setAllocationDeleteActionStatus(state, action: PayloadAction<boolean>) {
      state.allocationDeleteStatus = action.payload;
    },
    fetchAllocationListFailure(state, action: PayloadAction<IFailedPayload>) {
      state.loading = false;
      state.error = action.payload;
    },
    getDistinctValuesForAllocationList(
      state,
      action: PayloadAction<{
        agencyId: string;
        columnName: string;
        filters?: any;
      }>
    ) {
      state.distinctValuesLoading = true;
    },
    getDistinctValuesForAllocationListSuccess(
      state,
      action: PayloadAction<{ distinctValues: string[] }>
    ) {
      state.distinctValues = action.payload.distinctValues;
      state.distinctValuesLoading = false;
    },
    getDistinctValuesForAllocationListFailure(
      state,
      action: PayloadAction<IFailedPayload>
    ) {
      state.distinctValuesLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchAllocationList,
  fetchAllocationListSuccess,
  fetchAllocationListFailure,
  setAllocationListPage,
  setAllocationListPageSize,
  setAllocationListData,
  setAllocationDeleteActionStatus,
  getDistinctValuesForAllocationList,
  getDistinctValuesForAllocationListSuccess,
  getDistinctValuesForAllocationListFailure,
} = allocationListSlice.actions;

export default allocationListSlice.reducer;
